export const useOnboardingGeoBlock = () => {
	return {
		success: true,
		pending: false,
		error: null,
		isOnboardingGeoBlocked: false,
	};
};
